const EditImageControls = ({ zoom, setZoom, showCroppedImage }) => {
  return (
    <div className="flex flex-col sm:flex-row py-2 items-center sm:justify-center bg-white">
      <label className="flex flex-col sm:flex-row items-center mr-4 mb-4 sm:mb-0">
        <span className="mr-2 text-black font-bold">Zoom Image In/Out: </span>
        <input
          type="range"
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          aria-labelledby="Zoom"
          onChange={(e) => {
            setZoom(e.target.value);
          }}
          className="bg-red-800"
        />
      </label>
      <button
        type="button"
        onClick={showCroppedImage}
        className="p-2 px-4 bg-artfulRed rounded-lg shadow-lg text-white hover:font-bold focus:font-bold transistion-all max-w-fit"
      >
        Click to Crop Image!
      </button>
    </div>
  );
};

export default EditImageControls;
